import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const DataUploadRunButtonStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "data-upload-run-button",
})`
  button {
    width: 128px;
  }
`;
